import { useMemo } from 'react'
import { FlightsClassTypes } from 'constants/flight'
import { MALDIVES_BUNDLE_DEFAULT_GUESTS } from 'constants/charterFlight'
import { MALDIVES_CHARTER_ROUTE } from 'api/lib/flightDealMap'
import { sumUpOccupancies } from 'lib/offer/occupancyUtils'
import { useCheapestBundlePrice } from './MaldivesDirectSearchPage/hooks/useCheapestBundlePrice'
import { getMaldivesBannerPriceDisplay } from './getMaldivesBannerPriceDisplay'

interface UseMaldivesBannerPriceParams {
  enabled: boolean
  nights: number
  rooms: Array<App.Occupants>
  useMemberPrice: boolean
  checkIn?: string
}

export function useMaldivesBannerPrice({
  enabled,
  nights,
  rooms,
  useMemberPrice,
  checkIn,
}: UseMaldivesBannerPriceParams) {
  const bannerBundleData = useCheapestBundlePrice({
    checkIn,
    nights,
    rooms,
    fareClass: FlightsClassTypes.ECONOMY,
    charterBundleRoute: MALDIVES_CHARTER_ROUTE,
    useMemberPrice,
    disabled: !enabled,
  })

  return useMemo(() => getMaldivesBannerPriceDisplay({
    enabled,
    bannerBundleData,
    guestCount: sumUpOccupancies(rooms) || MALDIVES_BUNDLE_DEFAULT_GUESTS,
  }), [enabled, bannerBundleData, rooms])
}
